import {
  AnimatedButtonContainer,
  AnimatedButtonRow,
  Button,
} from "@babackapp/customer-ui/components/button";
import {
  Header,
  HeaderDescription,
  HeaderTitle,
  SectionHeader,
} from "@babackapp/customer-ui/components/header";
import {
  OptionsList,
} from "@babackapp/customer-ui/components/option";
import { RadioGroup } from "@babackapp/customer-ui/components/radio-group";
import {
  ReceiptLine,
  ReceiptLineLabel,
  ReceiptLineValue,
} from "@babackapp/customer-ui/components/receipt-line";
import { WidgetPage } from "@babackapp/customer-ui/components/widget-page";
import { formatPrice } from "@babackapp/return-widget-components/utils/format-price";
import { Separator } from "@babackapp/ui/components/separator";
import { EnterIcon } from "@radix-ui/react-icons";
import { ShoppingBagIcon } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useCheckout } from "../hooks/use-checkout";
import { ShippingRateOption } from "./shipping-rate-option";

export function Checkout() {
  const navigate = useNavigate();
  const {
    financialSummary,
    shippingRates,
    selectedRateId,
    selectRate,
    canProceed,
    onProceed,
    isLoadingRates,
  } = useCheckout();

  const needsPayment = financialSummary.amountDue > 0;
  const hasExchangeCredit = financialSummary.exchangeTotal > 0;

  const handleGoShopping = () => navigate("../shop-now");

  return (
    <WidgetPage>
      <Header>
        <HeaderTitle>Paiement</HeaderTitle>
        <HeaderDescription>
          {needsPayment
            ? "Pour confirmer votre retour, veuillez payer les frais supplémentaires."
            : "Vérifiez le récapitulatif de votre retour avant de confirmer."}
        </HeaderDescription>
      </Header>

      <div className="w-full mt-4 flex flex-col gap-6">
        <div className="flex flex-col gap-2">
          {financialSummary.refundTotal > 0 && (
            <ReceiptLine>
              <ReceiptLineLabel>Total à rembourser</ReceiptLineLabel>
              <ReceiptLineValue>
                {formatPrice(financialSummary.refundTotal, financialSummary.currency)}
              </ReceiptLineValue>
            </ReceiptLine>
          )}
          {financialSummary.exchangeTotal > 0 && (
            <ReceiptLine>
              <ReceiptLineLabel>Total échange</ReceiptLineLabel>
              <ReceiptLineValue>
                {formatPrice(financialSummary.exchangeTotal, financialSummary.currency)}
              </ReceiptLineValue>
            </ReceiptLine>
          )}
          {financialSummary.discountTotal > 0 && (
            <ReceiptLine>
              <ReceiptLineLabel>Bon de réduction</ReceiptLineLabel>
              <ReceiptLineValue>
                {formatPrice(financialSummary.discountTotal, financialSummary.currency)}
              </ReceiptLineValue>
            </ReceiptLine>
          )}
          {needsPayment && (
            <>
              <Separator className="my-1" />
              <ReceiptLine>
                <ReceiptLineLabel className="font-medium text-foreground">
                  Montant dû
                </ReceiptLineLabel>
                <ReceiptLineValue className="font-medium text-foreground">
                  {formatPrice(financialSummary.amountDue, financialSummary.currency)}
                </ReceiptLineValue>
              </ReceiptLine>
            </>
          )}
        </div>

        {needsPayment && (
          <div className="flex flex-col gap-3">
            <SectionHeader>Choisissez un mode de livraison</SectionHeader>
            {isLoadingRates && (
              <p className="text-sm text-muted-foreground">
                Chargement des options de livraison…
              </p>
            )}
            {!isLoadingRates && shippingRates.length > 0 && (
              <OptionsList>
                <RadioGroup value={selectedRateId ?? ""} onValueChange={selectRate}>
                  {shippingRates.map((rate) => (
                    <ShippingRateOption
                      key={rate.handle}
                      rate={rate}
                      currency={financialSummary.currency}
                    />
                  ))}
                </RadioGroup>
              </OptionsList>
            )}
          </div>
        )}
      </div>

      <AnimatedButtonRow variants={{}}>
        {hasExchangeCredit ? (
          <AnimatedButtonContainer layoutId="shop-now-button" variants={{}}>
            <Button onClick={handleGoShopping}>
              <ShoppingBagIcon />
              Choisir mes articles
            </Button>
          </AnimatedButtonContainer>
        ) : (
          <AnimatedButtonContainer layoutId="line-item-confirm-button" variants={{}}>
            <Button disabled={!canProceed} onClick={onProceed}>
              <EnterIcon />
              Confirmer
            </Button>
          </AnimatedButtonContainer>
        )}
      </AnimatedButtonRow>
    </WidgetPage>
  );
}
